import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

const ReviewNotification = ({ order, onDismiss, onAutoHide }) => {
  const [visible, setVisible] = useState(false)
  const navigate = useNavigate()

  useEffect(() => {
    // Show notification with a slight delay for smooth animation
    const showTimer = setTimeout(() => setVisible(true), 500)

    // Auto-hide after 15 minutes (900000 ms)
    const autoHideTimer = setTimeout(() => {
      setVisible(false)
      if (typeof onAutoHide === 'function') onAutoHide()
    }, 900000)

    return () => {
      clearTimeout(showTimer)
      clearTimeout(autoHideTimer)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [order.id])

  const handleDismiss = () => {
    setVisible(false)
    setTimeout(() => {
      if (onDismiss) onDismiss()
    }, 300)
  }

  const handleReviewClick = () => {
    // Close the modal first
    setVisible(false)

    // Navigate to orders page with delivered tab selected after modal closes
    setTimeout(() => {
      navigate('/orders', { state: { activeTab: 'delivered' } })
      if (onDismiss) onDismiss()
    }, 300)
  }

  if (!visible) return null

  return (
    <>
      {/* Backdrop */}
      <div
        onClick={handleDismiss}
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          opacity: visible ? 1 : 0,
          transition: 'opacity 0.3s ease',
          zIndex: 9998,
          pointerEvents: visible ? 'auto' : 'none'
        }}
      />

      {/* Modal */}
      <div
        style={{
          position: 'fixed',
          top: '50%',
          left: '50%',
          transform: visible ? 'translate(-50%, -50%) scale(1)' : 'translate(-50%, -50%) scale(0.8)',
          opacity: visible ? 1 : 0,
          maxWidth: '420px',
          width: '90%',
          backgroundColor: '#fff',
          borderRadius: '16px',
          boxShadow: '0 20px 60px rgba(0, 0, 0, 0.2)',
          padding: '24px',
          zIndex: 9999,
          transition: 'all 0.4s cubic-bezier(0.68, -0.55, 0.265, 1.55)',
          border: '2px solid #22c55e',
          fontFamily: 'inherit',
          pointerEvents: visible ? 'auto' : 'none'
        }}
      >
        {/* Close button */}
        <button
          onClick={handleDismiss}
          style={{
            position: 'absolute',
            top: '12px',
            right: '12px',
            background: 'transparent',
            border: 'none',
            cursor: 'pointer',
            color: '#94a3b8',
            fontSize: '20px',
            padding: '4px',
            lineHeight: 1,
            transition: 'color 0.2s'
          }}
          onMouseEnter={e => (e.target.style.color = '#64748b')}
          onMouseLeave={e => (e.target.style.color = '#94a3b8')}
          aria-label="Dismiss"
        >
          <i className="ph ph-x" />
        </button>

        {/* Icon */}
        <div
          style={{
            width: '48px',
            height: '48px',
            borderRadius: '50%',
            backgroundColor: '#dcfce7',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: '12px'
          }}
        >
          <i
            className="ph-fill ph-star"
            style={{
              fontSize: '24px',
              color: '#16a34a'
            }}
          />
        </div>

        {/* Content */}
        <h4
          style={{
            fontSize: '16px',
            fontWeight: '600',
            color: '#1e293b',
            margin: '0 0 8px 0',
            paddingRight: '20px'
          }}
        >
          How was your order?
        </h4>
        <p
          style={{
            fontSize: '14px',
            color: '#64748b',
            margin: '0 0 16px 0',
            lineHeight: '1.5'
          }}
        >
          We'd love to hear about your experience! Your feedback helps us serve you better.
        </p>

        {/* Action buttons */}
        <div
          style={{
            display: 'flex',
            gap: '8px'
          }}
        >
          <button
            onClick={handleReviewClick}
            style={{
              flex: 1,
              padding: '10px 16px',
              backgroundColor: '#22c55e',
              color: '#fff',
              border: 'none',
              borderRadius: '8px',
              fontSize: '14px',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'background-color 0.2s'
            }}
            onMouseEnter={e => (e.target.style.backgroundColor = '#16a34a')}
            onMouseLeave={e => (e.target.style.backgroundColor = '#22c55e')}
          >
            Leave a Review
          </button>
          <button
            onClick={handleDismiss}
            style={{
              padding: '10px 16px',
              backgroundColor: '#f1f5f9',
              color: '#64748b',
              border: 'none',
              borderRadius: '8px',
              fontSize: '14px',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'background-color 0.2s'
            }}
            onMouseEnter={e => (e.target.style.backgroundColor = '#e2e8f0')}
            onMouseLeave={e => (e.target.style.backgroundColor = '#f1f5f9')}
          >
            Maybe Later
          </button>
        </div>
      </div>
    </>
  )
}

export default ReviewNotification
